import DHowAnalyse from './DHowAnalyse'

export default DHowAnalyse
